import { useGetModelInfoQuery } from './api-slice';
import { jrModelSelector } from './configurator-selectors';
import { useAppSelector } from './hooks';
import { sessionIdSelector, useDataRequestLang } from './main-slice';

export function useModelInfoData() {
    const lang = useDataRequestLang();
    const sessionId = useAppSelector(sessionIdSelector) ?? '';
    const jrmodel = useAppSelector(jrModelSelector);
   return useGetModelInfoQuery({jrmodel: jrmodel!, lang, sessionId}, { skip: jrmodel === undefined });
}